var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOspedale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 27.5",
    style: {
      enableBackground: "new 0 0 30 27.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Component_262_16",
    transform: "translate(0.532 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20071"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_161",
    style: {
      fill: "none",
      stroke: "#045195",
      strokeWidth: 1.5,
      strokeMiterlimit: 10
    },
    x1: 14.6,
    y1: 3.8,
    x2: 14.6,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_162",
    style: {
      fill: "none",
      stroke: "#045195",
      strokeWidth: 1.5,
      strokeMiterlimit: 10
    },
    x1: 17.7,
    y1: 6.6,
    x2: 11.4,
    y2: 6.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11529",
    style: {
      fill: "none",
      stroke: "#045195",
      strokeWidth: 1.5,
      strokeMiterlimit: 10
    },
    d: "M15.8,0h-2.6 c-3,0-5.4,2.1-5.4,4.6V26h4.3v-6.1H17V26h4.3V4.6C21.2,2.1,18.8,0,15.8,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3196",
    style: {
      fill: "none",
      stroke: "#045195",
      strokeWidth: 1.5,
      strokeMiterlimit: 10
    },
    d: "M4.9,4.2L4.9,4.2L4.9,4.2 V26l0,0H0.2l0,0V8.9C0.2,6.3,2.3,4.2,4.9,4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3205",
    style: {
      fill: "none",
      stroke: "#045195",
      strokeWidth: 1.5,
      strokeMiterlimit: 10
    },
    d: "M24,4.2L24,4.2 c2.6,0,4.6,2.1,4.6,4.6V26l0,0H24l0,0V4.2L24,4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11578",
    style: {
      fill: "none",
      stroke: "#045195",
      strokeWidth: 1.5
    },
    d: "M4.5,11.1H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11581",
    style: {
      fill: "none",
      stroke: "#045195",
      strokeWidth: 1.5
    },
    d: "M24.4,11.1h4.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11579",
    style: {
      fill: "none",
      stroke: "#045195",
      strokeWidth: 1.5
    },
    d: "M4.6,13.8H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11582",
    style: {
      fill: "none",
      stroke: "#045195",
      strokeWidth: 1.5
    },
    d: "M24.4,13.8h4.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11580",
    style: {
      fill: "none",
      stroke: "#045195",
      strokeWidth: 1.5
    },
    d: "M4.6,16.6H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11583",
    style: {
      fill: "none",
      stroke: "#045195",
      strokeWidth: 1.5
    },
    d: "M24.4,16.6h4.6"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_169",
    style: {
      fill: "none",
      stroke: "#045195",
      strokeWidth: 1.5,
      strokeMiterlimit: 10
    },
    x1: 18,
    y1: 12.4,
    x2: 11.1,
    y2: 12.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_170",
    style: {
      fill: "none",
      stroke: "#045195",
      strokeWidth: 1.5,
      strokeMiterlimit: 10
    },
    x1: 18,
    y1: 15.1,
    x2: 11.1,
    y2: 15.1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOspedale);
export default __webpack_public_path__ + "static/media/Ospedale.9f4a95104b0a19ee03941f0ba3215d17.svg";
export { ForwardRef as ReactComponent };